<script>
    import { mapState } from 'vuex';

    export default {
        name: 'alert-component',
        data() {
            return {
                alert: {
                    visible: false,
                    type: '',
                    message: '',
                    linkText: '',
                    linkRoute: '',
                }
            };
        },
        computed: {
			...mapState([
				'isOpenAside'
			])
		},
        methods: {
            showAlert(type, message, linktext, linkroute) {
                this.alert.visible = true;
                this.alert.type = type;
                this.alert.message = message;
                this.alert.linkText = linktext;
                this.alert.linkRoute = linkroute;
                // setTimeout(() => {
                //     this.closeAlert();
                // }, 7000);
            },
            closeAlert() {
                this.alert.visible = false;
                this.alert.type = '';
                this.alert.message = '';
                this.alert.linkText = '';
                this.alert.linkRoute = '';
            }
        },
        mounted(){
        }
    };
</script>